module.exports = __webpack_public_path__ + "static/NeueMontreal-Light-b60d4716f541a80600d53580598945dd.woff";